class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    // Auto-close after a short delay (3 seconds) for a lighter UX
    if (this._autoCloseTimer) {
      clearTimeout(this._autoCloseTimer);
    }
    const startAutoClose = () => {
      this._autoCloseTimer = setTimeout(() => {
        if (this.notification.classList.contains('active')) {
          this.close();
        }
      }, 3000);
    };
    startAutoClose();

    // Pause auto-close on hover or focus to allow clicking buttons
    const pause = () => {
      if (this._autoCloseTimer) {
        clearTimeout(this._autoCloseTimer);
        this._autoCloseTimer = null;
      }
    };
    const resume = () => {
      if (!this._autoCloseTimer && this.notification.classList.contains('active')) {
        startAutoClose();
      }
    };
    this._pauseHandler = pause;
    this._resumeHandler = resume;
    this.notification.addEventListener('mouseenter', pause);
    this.notification.addEventListener('mouseleave', resume);
    this.notification.addEventListener('focusin', pause);
    this.notification.addEventListener('focusout', resume);

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    if (this._autoCloseTimer) {
      clearTimeout(this._autoCloseTimer);
      this._autoCloseTimer = null;
    }

    if (this._pauseHandler) {
      this.notification.removeEventListener('mouseenter', this._pauseHandler);
      this.notification.removeEventListener('mouseleave', this._resumeHandler);
      this.notification.removeEventListener('focusin', this._pauseHandler);
      this.notification.removeEventListener('focusout', this._resumeHandler);
      this._pauseHandler = null;
      this._resumeHandler = null;
    }

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
